// Created by administrator on 2017/8/11

export default [
    {
        path: '/',
        name: 'projectmanagement',
        component: resolve => require(['../components/views/contract/welcome.vue'], resolve)
    },

    {
        path: 'steelReportList',
        name: 'steelReportList',
        component: resolve => require(['../components/views/report/steel/steelReportList.vue'], resolve)
    },

    {
        path: 'RGjhjxn',
        name: 'RGjhjxn',
        component: resolve => require(['../components/views/report/steel/RGjhjxn.vue'], resolve)
    },

    {
        path: 'RGjjxlj',
        name: 'RGjjxlj',
        component: resolve => require(['../components/views/report/steel/RGjjxlj.vue'], resolve)
    },

    {
        path: 'RJjjy',
        name: 'RJjjy',
        component: resolve => require(['../components/views/report/steel/RJjjy.vue'], resolve)
    },



    {
        path: 'RSjdkz',
        name: 'RSjdkz',
        component: resolve => require(['../components/views/report/brick/RSjdkz.vue'], resolve)
    },

    {
        path: 'RSjptz',
        name: 'RSjptz',
        component: resolve => require(['../components/views/report/brick/RSjptz.vue'], resolve)
    },

    {
        path: 'RZyjqhnt',
        name: 'RZyjqhnt',
        component: resolve => require(['../components/views/report/brick/RZyjqhnt.vue'], resolve)
    },


    {
        path: 'RHntks',
        name: 'RHntks',
        component: resolve => require(['../components/views/report/concrete/RHntks.vue'], resolve)
    },


    {
        path: 'RHntkyqd',
        name: 'RHntkyqd',
        component: resolve => require(['../components/views/report/concrete/RHntkyqd.vue'], resolve)
    },


    {
        path: 'RHntpbsj',
        name: 'RHntpbsj',
        component: resolve => require(['../components/views/report/concrete/RHntpbsj.vue'], resolve)
    },


    {
        path: 'RSjpbsj',
        name: 'RSjpbsj',
        component: resolve => require(['../components/views/report/mortar/RSjpbsj.vue'], resolve)
    },

    {
        path: 'RHntkyqd',
        name: 'RHntkyqd',
        component: resolve => require(['../components/views/report/mortar/RHntkyqd.vue'], resolve)
    },

    {
        path: 'RSjy',
        name: 'RSjy',
        component: resolve => require(['../components/views/report/cement/RSjy.vue'], resolve)
    },

    {
        path: 'RSsjy',
        name: 'RSsjy',
        component: resolve => require(['../components/views/report/cement/RSsjy.vue'], resolve)
    },

    {
        path: 'RSnjy',
        name: 'RSnjy',
        component: resolve => require(['../components/views/report/cement/RSnjy.vue'], resolve)
    },



    {
        path: 'Shop',
        name: 'Shop',
        component: resolve => require(['../components/views/report/steel/Shop.vue'], resolve)
    },










]




// WEBPACK FOOTER //
// ./src/router/report.js